module.exports = __webpack_public_path__ + "img/alipay.2216f993.png";